import type { Team } from '@sine/sine-team-switcher';

import authService from '../authentication/auth.service';
import { authHelpers } from '../authentication/auth.service';
import pendoService from '../authentication/pendo.service';
import rxEventHub, { RxEvent } from '../services/events/rx';
import teamService from '../services/team/team.service';
import teamSwitcherService, { teamSwitcherInterceptor } from './teamSwitcher.service';

export class TeamScopingService {
  /**
   * Keeps track of the current selected team.
   * Useful for comparing the active team with the next team from the Team Switcher.
   * For all other cases use `teamSwitcherService.getCurrentTeam()`.
   */
  public activeTeam?: Team;
  private isLoadingTeams = false;

  initialiseTeamScoping() {
    rxEventHub.on(RxEvent.LOGOUT, () => {
      teamSwitcherInterceptor.stopIntercepting();
      teamSwitcherService.removeCurrentTeam();
      this.activeTeam = undefined;
    });
  }

  async fetchUserMetaData() {
    const { userDetails: auth } = authService.getAuthState();
    const team = teamSwitcherService.getCurrentTeam();

    return { auth, team };
  }

  setActiveTeam(team: Team) {
    this.activeTeam = team;
    authHelpers.clearPermissions();
  }

  async initializePendoWithMetadata() {
    const { auth, team } = await this.fetchUserMetaData();
    if (auth) await pendoService.initializePendoMetadata(auth, team);
  }

  async teamsCallback() {
    this.isLoadingTeams = true;

    const sortedTeams = await teamService.getMyTeams();

    this.isLoadingTeams = false;

    return { sortedTeams, allTeamsWithMultiTeamEnabled: [] };
  }
}

const teamScopingService = new TeamScopingService();
export default teamScopingService;
